export default __webpack_public_path__ + "static/media/wickel_hardcase.03ab2937.png";